<template>
    <div class="news-content-container">
      <back-open-chenter />
      <div class="news-content-panel">
        <div class="news-title">全球数字贸易博览会丨腾讯优图亮相第三届数贸会，速来体验！</div>
        <div class="news-date">2024年09月26日</div>
        <div class="news-content">
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
            </div>
          </div>
          <p>
            9月25日-29日，全球顶尖科技汇聚的
            <span class="mark-text highlight">第三届全球数字贸易博览会</span>
            （简称数贸会）在杭州大会展中心正式举办啦。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/newscenter/news56.png"/>
            </div>
          </div>
          <p>
            今年的数贸会在往届基础上加码升级，综合展示展区、丝路电商展区、数据与金融展区、人工智能展区、智慧城市展区、数字文娱展区、数智出行展区、数字医疗展区、消费电子展区等9个展区竞相亮相，无数新科技产品首发，为观众带来数字贸易领域最新动向。
          </p>
          <p>
            <span class="mark-text highlight">《黑神话：悟空》正式版线下亮相，60多款顶尖机器人集体来袭，圆明园兽首裸眼3D，100+黑科技眼花缭乱，8K视觉环绕……</span>
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news56/news56_1.gif"/>
            </div>
          </div>
          <p>
            都说科技的进化是以秒论的……而在这里，只有震撼：这世界奔跑速度可太快了！
          </p>
          <p>
            无论是自己与世界先进接轨，还是带娃来体验全球新科技的魅力，这一趟，真的一定要来！小编先带你提前感受一下吧！<strong>（内容实在太多，只能挑部分给大家看咯）</strong>。
          </p>
          <div class="news-content-mark">
            <h2>全球头部3A大作</h2>
            <h2>《黑神话：悟空》正式版线下亮相</h2>
          </div>
          <p class="short-center">（综合展示区）</p>
          <p>
            《黑神话：悟空》是国内真正意义上的第一款3A游戏，有多火就不用赘述啦。
          </p>
          <p>
            这次数贸会，是《黑神话：悟空》正式版的<span class="mark-text highlight">线下亮相</span>。而且！现场提供多端游戏试玩！
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news56/news56_2.png"/>
            </div>
          </div>
          <p>
            《黑神话：悟空》现场联手英伟达、索尼互动娱乐、联想拯救者、海信视像等多家全球科技硬件厂商，展现不同硬件与体验场景，大家可直接互动与上手，体验这款风靡全球的西游单机大作带来的极致视觉体验。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news56/news56_3.png"/>
            </div>
          </div>
          <div class="news-content-mark">
            <h2>这里被60多款机器人占领了</h2>
          </div>
          <p class="short-center">（人工智能展区）</p>
          <p>
            去年数贸会的多款机器人已经让大家大开眼界、流连忘返：弹钢琴、下棋……而今年，数贸会更是直接上大招：首次设立了
            <span class="mark-text highlight">智能/人形机器人展区</span>！
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news56/news56_4.gif"/>
              <span>科幻片真的要照进现实了</span><br/>
              <span>图为效果图</span>
            </div>
          </div>
          <p>
            60多款国内外机器人齐聚一堂，钛虎、行思无界、宇树、五八智能……现场各大机器人前沿科技公司拿出自己的绝活，恍若让观众进入一个未来世界。
          </p>
          <p>
            提供自助咖啡服务的咖啡机器人，能帮忙介绍最新科技应用与机器人技术的AI智能服务机器人，能帮你跑腿的服务机器人……
          </p>
          <div class="news-content-mark">
            <h2>即拍即取的AI照相机</h2>
          </div>
          <p>
            今年，腾讯优图实验室也再次亮相数贸会，为观众带来诚意满满的互动体验项目——“AI照相机”。观众只需在现场拍摄一张照片，就能通过腾讯优图实验室自研的图生图算法将照片进行AI技术转换，得到多种风格的照片，动漫、3D、水彩、插画、黏土、玉石等不同风格任你选择。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news56/news56_5.gif"/>
            </div>
          </div>
          <p>
            作为腾讯旗下顶级的AI实验室，腾讯优图实验室自成立以来，始终聚焦AI技术研究与落地，致力于前沿技术在多行业场景的研究与落地。未来，腾讯优图实验室将继续拓展AI在各个领域的落地与应用，让AI更好地融入日常生活领域，给大家带来更多有创意有趣的互动体验。
          </p>
          <div>
            <div class="image-panel">
              <img width="39" src="../img/detail/Information/news56/news56_6.gif"/>
            </div>
          </div>
          <p class="short-center">
            <span class="mark-text highlight">真的，一天根本不够逛👏👏👏</span>！
          </p>
          <p class="short-center">
            以上，只是这次数贸会的一小部分
          </p>
          <p class="short-center">
            整整8个区，15万方，小编劝你穿好平底鞋
          </p>
          <p class="short-center">
            更多的神秘，要等你现场来亲自揭晓
          </p>
          <p class="short-center">
            最后，附上注册tips
          </p>
          <div class="download-article-wrap">
            <div class="news-content-mark">
              <p>↓参观注册↓</p>
            </div>
            <div>
              <div class="image-panel">
                <img width="159" src="../img/detail/Information/news56/news56_7.png"/>
              </div>
            </div>
            <div class="news-content-mark">
              <p>↓参观时间↓</p>
            </div>
            <p class="short-center">9月25日-28日 09:00-17：00</p>
            <p class="short-center">9月29日 09:00-14:00</p>
            <p class="short-center">(以官方具体最新通知为准)</p>
            <div class="news-content-mark">
              <p>↓举办地点↓</p>
            </div>
            <p class="short-center">杭州大会展中心</p>
            <p class="short-center">（萧山区美狮线与岩南线交叉路口往西）</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
  export default {
    name: 'News56',
    components: {
      BackOpenChenter
    }
  };
  </script>
  
  <style lang="less" scoped>
  @import "./news.less";
  .news-content {
    margin: 0 auto;
    .image-panel {
      max-width: 667px;
      text-align: center;
      img {
        max-width: 667px;
      }
      span {
        font-size: 12px;
        color: #858585;
      }
    }
    .highlight {
      color: #0052FF;
    }
    .end-divide {
      width: 120px;
      height: 2px;
      margin: 20px auto;
      background: #0152d9;
    }
    .download-article-wrap {
      margin: 0 auto;
      padding: 5px 3px;
      border: 3px solid rgb(1, 82, 217);
      font-family: PingFangSC-light;
      .download-article {
        padding: 5px 10px;
        border-left: 1px solid rgb(1, 82, 217);
        border-right: 1px solid rgb(1, 82, 217);
      }
    }
    .news-literature {
      max-height: 180px;
      padding: 15px;
      overflow-y: scroll;
      background-color: #ebebeb;
    }
    .short-center{
      text-align: center;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News56.vue